import { __decorate } from "tslib";
import { Vue, Component, Watch } from 'vue-property-decorator';
import Modal from '@/components/v3/Modal.vue';
import { PRIMARY_APP_DEFAULT_ERR_MSG, PRIMARY_APP_NEW_ERR_MSG } from '@/helpers/constants/app';
import { AlertType } from '@/helpers/entities/enums/AlertType';
let TheAlert = class TheAlert extends Vue {
    get toggle() {
        return this.$store.state.toggleAlert;
    }
    get alertMessage() {
        return this.$store.state.alertMessage;
    }
    get alertType() {
        return this.$store.state.alertType;
    }
    get youtubeIcon() {
        return require('@/assets/icons/youtube.svg');
    }
    get isPersistentAlert() {
        return this.isPrimaryAppError;
    }
    get showVideoGuide() {
        if (this.isPrimaryAppError) {
            return this.isPrimaryAppError;
        }
        return false;
    }
    get isPrimaryAppError() {
        return (this.alertMessage.includes(PRIMARY_APP_NEW_ERR_MSG) ||
            this.alertMessage.includes(PRIMARY_APP_DEFAULT_ERR_MSG));
    }
    get videoLink() {
        if (this.showVideoGuide) {
            if (this.isPrimaryAppError) {
                return 'https://www.youtube.com/embed/pP6EhDPLyYg?enablejsapi=1';
            }
        }
        return '';
    }
    get videoTitle() {
        if (this.showVideoGuide) {
            if (this.isPrimaryAppError) {
                return 'Setting Up ChatGenie as Your Primary Receiver on Facebook';
            }
        }
        return '';
    }
    onToggleChange(toggle) {
        const threeSeconds = 3000;
        if (this.isPersistentAlert) {
            return;
        }
        // Close alert after Three Seconds
        if (toggle) {
            setTimeout(() => {
                this.$store.commit('toggleAlert', false);
                this.$store.commit('clearAlertMessage');
            }, threeSeconds);
        }
    }
    onAlertMessageChange(value, oldValue) {
        const threeSeconds = 3000;
        // if the previous error message should be persistent
        // set back to the previous error message after 3secs
        if (oldValue.includes(PRIMARY_APP_NEW_ERR_MSG) ||
            oldValue.includes(PRIMARY_APP_DEFAULT_ERR_MSG)) {
            setTimeout(() => {
                this.$store.commit('setAlertType', AlertType.error);
                this.$store.commit('populateAlertMessage', oldValue);
            }, threeSeconds);
        }
    }
};
__decorate([
    Watch('toggle')
], TheAlert.prototype, "onToggleChange", null);
__decorate([
    Watch('alertMessage')
], TheAlert.prototype, "onAlertMessageChange", null);
TheAlert = __decorate([
    Component({
        components: {
            Modal,
        },
    })
], TheAlert);
export default TheAlert;
